<div class="container">
  <h1 style="text-align:center">Dealer functionalities are currently <i style="color:red">disabled</i></h1>
  <div class="search-div">
    <button disabled mat-raised-button (click)="onCreate()">
      <mat-icon>add</mat-icon>Create
    </button>
    <mat-form-field class="search-form-field" floatLabel="never">
      <input matInput #Search type="text" placeholder="Search" (keyup)="doFilter($event.target.value)">
      <button mat-button matSuffix mat-icon-button aria-label="Clear">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <button disabled mat-raised-button (click)="onImport()" color="warn">
      <mat-icon>input</mat-icon>&nbsp;&nbsp;Import
    </button>&nbsp;&nbsp;
    <button disabled mat-raised-button (click)="onGenerateAds()" color="primary">
      <mat-icon>cached</mat-icon>&nbsp;&nbsp; Generate Ads
    </button>&nbsp;&nbsp;
    <button disabled mat-raised-button (click)="onCompareAds()">
      <mat-icon>backup</mat-icon> Upload using API
    </button>
    <button disabled mat-raised-button (click)="onBackgroundJob()">
      <mat-icon>backup</mat-icon> Background Job
    </button>
    <button disabled mat-raised-button (click)="onBackgroundJob()">
      <mat-icon>backup</mat-icon> ANC
    </button>
  </div>
  <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="20px">
    <mat-table [dataSource]="dealerTableDataSource" fxFlex="1" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Dealer ID  </mat-header-cell>
        <mat-cell *matCellDef="let element"><mat-checkbox disabled name="ignore"></mat-checkbox> &nbsp;&nbsp; {{element.id}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Name  </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Location  </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.location}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="postcode">
        <mat-header-cell *matHeaderCellDef mat-sort-header> PostCode   </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.postCode}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="distance">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Distance   </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.distance}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="maxCPC">
        <mat-header-cell *matHeaderCellDef mat-sort-header> MaxCPC   </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.maxCpc}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="displayName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Display Name   </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.displayName}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="displaylocation">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Display Location   </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.displayLocation}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button disabled mat-icon-button (click)="onEdit(element)"><mat-icon>launch</mat-icon></button>
          <button disabled mat-icon-button color="warn" (click)="onDelete(element)"><mat-icon>delete_outline</mat-icon></button>
          <!--<button mat-icon-button color="primary" (click)="onInfo(element)"><mat-icon>info_outline</mat-icon></button>-->
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="loading">
        <mat-footer-cell *matFooterCellDef colspan="4">
          Loading Data ....
        </mat-footer-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dealers != null }"></mat-footer-row>
    </mat-table>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,20,100]">

    </mat-paginator>
  </div>

</div>
